var map = {
	"./accenture.jpg": [
		67842,
		842
	],
	"./amazon.png": [
		22032,
		32
	],
	"./cts.png": [
		68222,
		222
	],
	"./facebook-logo.png": [
		12694
	],
	"./facebook.jpg": [
		27088,
		88
	],
	"./facebook.svg": [
		63212,
		212
	],
	"./flipkart.jpg": [
		69371,
		371
	],
	"./google-logo.png": [
		20485
	],
	"./google.jpg": [
		87493,
		493
	],
	"./instagram.svg": [
		22188,
		188
	],
	"./linkedin.svg": [
		60150,
		150
	],
	"./microsoft.png": [
		46962,
		962
	],
	"./tcs.png": [
		85628,
		628
	],
	"./twitter-x.svg": [
		72230,
		230
	],
	"./wipro.jpg": [
		44311,
		311
	],
	"./zoho.png": [
		46314,
		314
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 80140;
module.exports = webpackAsyncContext;